import { IType } from './common';
import { IMappedType } from './mapped-type.interface';
import {
  inheritPropertyInitializers,
  inheritTransformationMetadata,
  inheritValidationMetadata,
} from './type-helpers.utils';
import { TRemoveFieldsWithType } from './types/remove-fields-with-type.type';

export function OmitType<T, K extends keyof T>(
  classRef: IType<T>,
  keys: readonly K[],
) {
  const isInheritedPredicate = (propertyKey: string) =>
    !keys.includes(propertyKey as K);

  abstract class OmitClassType {
    constructor() {
      inheritPropertyInitializers(this, classRef, isInheritedPredicate);
    }
  }

  inheritValidationMetadata(classRef, OmitClassType, isInheritedPredicate);
  inheritTransformationMetadata(classRef, OmitClassType, isInheritedPredicate);

  return OmitClassType as IMappedType<
    TRemoveFieldsWithType<Omit<T, (typeof keys)[number]>, unknown>
  >;
}
